import { createStore } from 'vuex';
import { User } from '@/store/modules/User';

export default createStore({
	modules: { User }
});
